<template>
  <div class="user-status-filter-item user-type">
    <label class="item-label" v-t.preserve="'appUserStatusFilterType.type'" />
    <filter-button-group bordered v-model="value" v-bind:buttons="buttons" />
  </div>
</template>

<script>
import FilterButtonGroup from '@/components/AppFilterButtonGroup.vue'

export default {
  name: 'AppUserStatusFilterType',
  components: {
    FilterButtonGroup,
  },
  props: {
    /**
     * 選択値
     * 「すべて」を選択する場合は null にする
     */
    target: {
      type: String,
      default: null,
    },
  },
  data: function () {
    return {
      // ローカル値
      value: this.target,
    }
  },
  computed: {
    /**
     * 選択肢のボタン定義
     * @type {Array.<Object>}
     */
    buttons: function () {
      return [
        { value: null, text: this.$t('appUserStatusFilterType.all') },
        {
          value: 'without',
          text: this.$t('appUserStatusFilterType.appUser'),
        },
        {
          value: 'only_rel',
          text: this.$t('appUserStatusFilterType.tagUser'),
        },
      ]
    },
    /**
     * イベント返却用の値
     * @type {Object}
     */
    resultValue: function () {
      return { target: this.value }
    },
    /**
     * イベント返却用のテキスト
     * @type {String}
     */
    resultText: function () {
      return this.value == null
        ? ''
        : this.buttons.find((b) => b.value === this.value)?.text || ''
    },
  },
  watch: {
    target: function (value) {
      this.value = value
    },
    value: function () {
      this.$_onChange()
    },
  },
  mounted: function () {
    // 初回結果表示のためにpropsの値で変更されたことにする
    this.$_onChange()
  },
  methods: {
    /**
     * 変更時処理
     */
    $_onChange: function () {
      /**
       * 選択値変更イベント
       * @param {Object} value 選択値
       * @param {String} text 選択値表示テキスト
       */
      this.$emit('changed', { value: this.resultValue, text: this.resultText })
    },
  },
}
</script>

<style lang="scss" scoped>
@use '../../../assets/scss/parts/user/user-status-filter-item';

$-all-button-width: 56px;

::v-deep .filter-button-group {
  width: 100%;

  .filter-group {
    display: flex;
    width: 100%;
    .btn:first-child {
      width: $-all-button-width;
      flex-shrink: 0;
    }
    .btn:nth-child(2),
    .btn:nth-child(3) {
      width: calc((100% - $-all-button-width) / 2);
      min-width: 112px;
    }
  }
}
</style>
